export default __webpack_public_path__ + "static/media/ic_carolus.1a6f7a07.png";